/**
 * Utility functions for handling subdomain and path-based routing
 */

/**
 * Checks if the current request is for an AI agent subdomain or path
 * @returns {object} { isAIAgent: boolean, agentType: string | null, isSubdomain: boolean }
 */
export const detectAIAgentRoute = () => {
  const hostname = window.location.hostname;
  const pathname = window.location.pathname;
  
  // Check for subdomain routing (ai-agent.innovaplus.be, ai-agent.localhost)
  const isAIAgentSubdomain = hostname.startsWith('ai-agent.');
  
  // Check for path-based routing (/ai-agent/*)
  const isAIAgentPath = pathname.startsWith('/ai-agent');
  
  const isAIAgent = isAIAgentSubdomain || isAIAgentPath;
  
  let agentType = null;
  if (isAIAgent) {
    if (isAIAgentSubdomain) {
      agentType = 'julia'; // Default agent for ai-agent subdomain
    } else if (isAIAgentPath) {
      // Extract agent type from path (/ai-agent/julia, /ai-agent/alex, etc.)
      const pathParts = pathname.split('/');
      agentType = pathParts[2] || 'julia'; // Default to julia if no specific agent
    }
  }
  
  return {
    isAIAgent,
    agentType,
    isSubdomain: isAIAgentSubdomain,
    isPath: isAIAgentPath
  };
};

/**
 * Gets the base path for AI agent routes
 * @param {boolean} isSubdomain - Whether we're using subdomain routing
 * @returns {string} The base path
 */
export const getAIAgentBasePath = (isSubdomain) => {
  return isSubdomain ? '' : '/ai-agent';
};

/**
 * Constructs an AI agent route URL
 * @param {string} agentType - The agent type (julia, alex, etc.)
 * @param {string} path - The specific path within the agent routes
 * @param {boolean} isSubdomain - Whether to use subdomain routing
 * @returns {string} The complete URL
 */
export const buildAIAgentRoute = (agentType, path = '', isSubdomain = false) => {
  if (isSubdomain) {
    const protocol = window.location.protocol;
    const baseDomain = window.location.hostname.replace(/^ai-agent\./, '');
    return `${protocol}//ai-agent.${baseDomain}${path}`;
  } else {
    return `/ai-agent/${agentType}${path}`;
  }
}; 